import React, { useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy py-8 border-t border-white/10 text-center" data-id="element-35">
        <div className="max-w-sales mx-auto px-6" data-id="element-36">
          <div className="flex items-center justify-center gap-6 mb-4" data-id="element-37">
            <button onClick={() => setActiveModal('privacy')} className="text-white/50 hover:text-amber text-sm underline underline-offset-2 transition-colors" data-id="element-38">
              Política de Privacidad
            </button>
            <span className="text-white/20" data-id="element-39">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-white/50 hover:text-amber text-sm underline underline-offset-2 transition-colors" data-id="element-40">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-white/40 text-sm" data-id="element-41">
            © {new Date().getFullYear()} El Protocolo del Hogar Silencioso.
            Todos los derechos reservados.
          </p>
          <p className="text-white/30 text-xs mt-2 max-w-2xl mx-auto" data-id="element-42">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-43">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-44">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-45">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-46">
                <h2 className="text-2xl font-bold text-navy" data-id="element-47">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Cerrar" data-id="element-48">
                  <X className="w-5 h-5 text-navy/60" data-id="element-49" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-navy/80 text-sm leading-relaxed space-y-4" data-id="element-50">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-51" /> : <TermsContent data-id="element-52" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-navy/50 mb-4" data-id="element-53">
        Última actualización: Abril 2026
      </p>

      <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-54">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-55">
        Recopilamos información personal que usted nos proporciona directamente
        al realizar una compra, como su nombre, dirección de correo electrónico
        e información de pago. No almacenamos datos de tarjetas de crédito;
        estos son procesados de forma segura por nuestro proveedor de pagos.
      </p>

      <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-56">
        2. Uso de la Información
      </h3>
      <p data-id="element-57">Utilizamos su información personal para:</p>
      <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-58">
        <li data-id="element-59">Procesar y entregar su compra.</li>
        <li data-id="element-60">Enviar comunicaciones relacionadas con su pedido.</li>
        <li data-id="element-61">Mejorar nuestros productos y servicios.</li>
        <li data-id="element-62">Enviar contenido promocional (solo con su consentimiento).</li>
      </ul>

      <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-63">
        3. Protección de Datos
      </h3>
      <p data-id="element-64">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger su información personal contra acceso no autorizado, pérdida o
        alteración.
      </p>

      <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-65">4. Cookies</h3>
      <p data-id="element-66">
        Nuestro sitio utiliza cookies para mejorar su experiencia de navegación
        y analizar el tráfico del sitio. Puede configurar su navegador para
        rechazar cookies, aunque esto puede afectar la funcionalidad del sitio.
      </p>

      <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-67">
        5. Derechos del Usuario
      </h3>
      <p data-id="element-68">
        Usted tiene derecho a acceder, rectificar o eliminar sus datos
        personales en cualquier momento. Para ejercer estos derechos, puede
        contactarnos a través de los canales indicados en nuestro sitio.
      </p>

      <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-69">
        6. Cambios a esta Política
      </h3>
      <p data-id="element-70">
        Nos reservamos el derecho de actualizar esta política en cualquier
        momento. Los cambios serán publicados en esta página con la fecha de
        actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-navy/50 mb-4" data-id="element-71">
        Última actualización: Abril 2026
      </p>

      <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-72">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-73">
        Al acceder a este sitio web y/o realizar una compra, usted acepta estar
        sujeto a estos Términos y Condiciones. Si no está de acuerdo con alguna
        parte de estos términos, no debe utilizar nuestro sitio.
      </p>

      <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-74">
        2. Producto Digital
      </h3>
      <p data-id="element-75">
        "El Protocolo del Hogar Silencioso" es un producto digital (PDF) que se
        entrega electrónicamente tras la confirmación del pago. El acceso es
        inmediato y se proporciona a través de un enlace de descarga.
      </p>

      <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-76">3. Uso Personal</h3>
      <p data-id="element-77">
        El contenido adquirido es para uso personal y no comercial. Queda
        prohibida la reproducción, distribución, modificación o reventa del
        material sin autorización expresa por escrito.
      </p>

      <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-78">4. Resultados</h3>
      <p data-id="element-79">
        Los resultados pueden variar según el cachorro, su raza, edad y la
        consistencia en la aplicación del protocolo. No garantizamos resultados
        específicos, ya que cada animal es diferente.
      </p>

      <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-80">
        5. Política de Reembolso
      </h3>
      <p data-id="element-81">
        Debido a la naturaleza digital del producto, todas las ventas son
        finales. Sin embargo, si no está satisfecho, puede contactarnos dentro
        de los 7 días posteriores a la compra para evaluar su caso.
      </p>

      <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-82">
        6. Limitación de Responsabilidad
      </h3>
      <p data-id="element-83">
        Este producto es de carácter educativo e informativo. No sustituye el
        consejo de un veterinario o un entrenador canino profesional
        certificado. El uso del protocolo es bajo su propia responsabilidad.
      </p>

      <h3 className="text-lg font-bold text-navy mt-6 mb-2" data-id="element-84">
        7. Modificaciones
      </h3>
      <p data-id="element-85">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación en el sitio.
      </p>
    </>;
}